import { Navigate, Route, Routes } from 'react-router-dom';
import FileDashboardPage from './FileDashboardPage';
import MyFilesPage from './MyFilesPage';
import SharedPage from './SharedPage';
import TrashPage from './TrashPage';

export default function FileManagerRoutes() {
  return (
    <Routes>
      <Route index element={<FileDashboardPage />} />
      <Route path="my-files" element={<MyFilesPage />} />
      <Route path="shared" element={<SharedPage />} />
      <Route path="trash" element={<TrashPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
